/** Two letters of an account code for its avatar: "atp_14-627@mail.ru" -> "A1". */
export const accountInitials = (code: string): string => {
	const parts = code.replace(/[^\p{L}\p{N}]+/gu, ' ').trim().split(' ')
	return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?'
}
